import InfiniteScroll from 'infinite-scroll'
import getNextPages from "./utils/getNextPages";
import renderPreloader from "./utils/renderPreloader";
import createEventListeners from "./utils/createEventListeners";
import createNewsWithinAdv from "../adv/createAdvBlocks/createNewsWithinAdv";
import createAdvBetweenNewses from "../adv/createAdvBlocks/createAdvBetweenNewses";
import initOnScroll from "../../tv24/js/es6/initOnScroll";
import reloadOntheio from "./utils/reloadOntheio";
import sendToPiwik from "../../tv24/js/analyticsTools/sendToPiwik";
import initViewCountForFirstNews from "./utils/initViewCountForFirstNews";
import createCatfish from "../adv/createAdvBlocks/createCatfish";
import createIntersectionObserver from "../adv/utils/createIntersectionObserver";
import destroyCatfish from "../adv/destroyAdvBlocks/destroyCatfish";
import renderFinanceCatfish from "../adv/createAdvBlocks/financeAdv/renderFinanceCatfish";

export default async function (opt) {
    initOnScroll({
        timeout: 0,
        scrollDepth: 10,
        func: initInfiniteScroll
    });

    reloadOntheio(opt.newsTitle, window.location.href, true);
    initViewCountForFirstNews(viewCounterObj[opt.newsId], opt.viewCountServiceDns);

    async function initInfiniteScroll(){
        createNewsWithinAdv(opt, undefined, 1);

        let nextPages = await getNextPages(opt);
        let elem = document.querySelector('.next-article-place');
        let infScroll = new InfiniteScroll(elem, {
            path: function () {
                return nextPages[this.loadCount];
            },
            append: '.next-article',
            history: 'push',
            historyTitle: true,
            status: '.page-load-status',
            onInit: renderPreloader('.next-article-place'),
            scrollThreshold: 1000,
            prefill: true
        });

        if(!opt.specialProject || opt.subsiteName === 'education' || opt.subsiteName === 'games'){
            createAdvBetweenNewses(1);
        }

        if(opt.subsiteName === 'finance'){
            renderFinanceCatfish();
            createIntersectionObserver('.adv-destroy', destroyCatfish)
        }

        sendToPiwik("scroll depth: 1");
        createEventListeners(infScroll, opt);

        if (window.innerWidth >= 1024  && !opt.withoutAds && (opt.subsiteName === '24')) {
            createCatfish(opt);
        }

        createIntersectionObserver('.adv-destroy', destroyCatfish);
    }
}